import { useState, useEffect, useRef } from "react";
import { IoChevronDown } from "react-icons/io5";
import { FaCheckCircle, FaRegCircle } from "react-icons/fa";

export default function SortDropdown({ selected, onApply, options = [] }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(selected);
    const dropdownRef = useRef(null);

    const handleApply = () => {
        setIsOpen(false);
        onApply(selectedOption);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    const currentLabel = options.find((o) => o.value === selectedOption)?.label || selectedOption;

    return (
        <div className="relative text-sm text-[#344054]" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen((v) => !v)}
                className="bg-[#F7F8FD] flex items-center px-4 py-2 rounded-full gap-1 font-medium"
            >
                <span>Sort:</span>
                <span className="text-[#101828]">{currentLabel}</span>
                <IoChevronDown size={16} className="text-[#6F6B7B]" />
            </button>

            {isOpen && (
                <div className="absolute z-20 mt-2 w-64 right-0 bg-white shadow-xl rounded-xl py-3 px-3">
                    <h4 className="text-sm font-semibold text-[#101828] mb-3">Sort by</h4>
                    <div className="space-y-3">
                        {options.map((opt) => (
                            <div
                                key={opt.value}
                                onClick={() => setSelectedOption(opt.value)}
                                className="flex items-center justify-between text-sm text-[#344054] cursor-pointer hover:text-[#6F00FF]"
                            >
                                <span>{opt.label}</span>
                                {selectedOption === opt.value ? (
                                    <FaCheckCircle className="text-[#6F00FF]" size={14} />
                                ) : (
                                    <FaRegCircle className="text-gray-300" size={14} />
                                )}
                            </div>
                        ))}
                    </div>

                    <button
                        onClick={handleApply}
                        className="w-full mt-5 bg-[#6F00FF] text-white text-sm rounded-lg py-2 font-medium"
                    >
                        Apply
                    </button>
                </div>
            )}
        </div>
    );
}
